import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

export interface DialogData {
  cabList: Array<string>
}

@Component({
  selector: 'app-lecture-dialog',
  templateUrl: './lecture-dialog.component.html',
  styleUrls: ['./lecture-dialog.component.scss']
})
export class LectureDialogComponent {
  cabList: Array<string> = [];
  displayedColumns: Array<string> = ['CAB', 'detail'];

  constructor(
    private dialogRef: MatDialogRef<LectureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.cabList = data.cabList;
  }
}
